import { useMemo, useCallback } from 'react';
import { atom, useAtom } from 'jotai';

const expansionStateAtom = atom({});

export const useRowExpansion = (rowKey) => {
  const [expansionStates, setExpansionState] = useAtom(expansionStateAtom);

  const isRowExpanded = expansionStates[rowKey] || false;

  const toggleRowExpansion = useCallback(
    (newState) => {
      setExpansionState((prevExpansionStates) => ({
        ...prevExpansionStates,
        [rowKey]: newState === true ? newState : !isRowExpanded,
      }));
    },
    [isRowExpanded, rowKey, setExpansionState]
  );

  const value = useMemo(
    () => ({
      isRowExpanded,
      toggleRowExpansion,
    }),
    [isRowExpanded, toggleRowExpansion]
  );

  return value;
};
